import { render } from "./RuiSmoke.vue?vue&type=template&id=94aa7126"
const script = {}
script.render = render

export default script